import * as types from '../types';
import {normalizeSocials} from '../utils/normalizeSocials';

const defaultState = {
  registrationFields: [
    {
      name: 'email',
      required: true,
      type: 'email'
    },
    {
      name: 'password',
      required: true,
      type: 'pass'
    }
  ],
  socialLinks: {
    primary: [],
    secondary: [],
    other: []
  },
  proxy: {
    login: true,
    registration: true,
    resetPassword: true
  },
  centralBlock: 'OFF', // LOGIN_PASS, LOGIN_PASS-TWO_STEPS, SMS, QR, SINGLE_EMAIL
  captcha: {
    value: null,
    mounted: false,
    visible: false
  },
  chineseCaptcha: {
    visible: false,
    values: null
  },
  externalWindow: false,
  deviceType: 'desktop',
  isIFrame: true,
  canShowSocialsOnRegistration: false,
  compactView: false,
  isUsernameEmail: true,
  blockHeight: 'auto',
  searchFieldValue: '',
  error: null,
  localization: {
    locale: 'en_US',
    lang: 'en',
    country: 'US',
    translation: 'en'
  },
  cdn: '',
  api: '',
  merchantApi: '',
  MFA_API: '',
  version: null,
  enableAnalytics: true,
  is_oauth2: false,
  privacyUrl: '',
  consentUrl: '',
  tosUrl: '',
  cookieUrl: ''
};

export default function xlReducer(state = defaultState, action) {
  switch (action.type) {
    case types.SET_BLOCK_HEIGHT:
      return {
        ...state,
        blockHeight: action.height
      };

    case types.SET_ANALYTICS:
      return {
        ...state,
        enableAnalytics: action.enableAnalytics
      };

    case types.SET_API:
      return {
        ...state,
        api: action.api,
        MFA_API: action.mfa
      };

    case types.SET_MERCHANT_API:
      return {
        ...state,
        merchantApi: action.merchantApi
      };

    case types.SET_CDN:
      return {
        ...state,
        cdn: action.cdn
      };

    case types.SET_PRIVACY_LINK:
      return {
        ...state,
        privacyUrl: action.link
      };

    case types.SET_CONSENT_LINK:
      return {
        ...state,
        consentUrl: action.link
      };

    case types.SET_COOKIE_LINK:
      return {
        ...state,
        cookieUrl: action.link
      };

    case types.SET_TOS_LINK:
      return {
        ...state,
        tosUrl: action.link
      };

    case types.SEARCH_AUTH_TYPE:
      return Object.assign({}, state, {
        searchFieldValue: action.text
      });

    case types.SET_DEVICE_TYPE:
      return {
        ...state,
        deviceType: action.data
      };

    case types.SET_CONFIG: {
      const registration = {};
      if (action.config.registrationFields.length > 0) {
        registration.registrationFields = action.config.registrationFields;
      }

      return {
        ...state,
        ...action.params,
        ...registration,
        canShowSocialsOnRegistration: action.config.show_social_auth_on_registration,
        isUsernameEmail: action.config.is_username_email,
        socialLinks: normalizeSocials(action.config.socialLinks),
        proxy: {
          ...state.proxy,
          login: action.config.proxyLogin,
          registration: action.config.proxyRegistration,
          resetPassword: action.config.proxyResetPassword
        }
      };
    }

    case types.SET_LOCALIZATION:
      return {
        ...state,
        localization: {
          ...state.localization,
          ...action.localization
        }
      };

    case types.SET_VERSION:
      return {
        ...state,
        version: action.version
      };

    case types.SET_IS_OAUTH2:
      return {
        ...state,
        is_oauth2: action.is_oauth2
      };

    case types.NOT_IFRAME:
      return {
        ...state,
        isIFrame: false
      };

    case types.SET_RECAPTCHA:
      return {
        ...state,
        captcha: {
          ...state.captcha,
          value: action.token
        }
      };

    case types.REMOVE_RECAPTCHA:
      return {
        ...state,
        captcha: {
          ...state.captcha,
          value: null
        }
      };

    case types.SHOW_CAPTCHA:
      return {
        ...state,
        captcha: {
          ...state.captcha,
          mounted: true,
          visible: true
        }
      };

    case types.HIDE_CAPTCHA:
      return {
        ...state,
        captcha: {
          ...state.captcha,
          visible: false
        }
      };

    case types.SHOW_CHINESE_CAPTCHA:
      return {
        ...state,
        chineseCaptcha: {
          ...state.chineseCaptcha,
          visible: true
        }
      };

    case types.HIDE_CHINESE_CAPTCHA:
      return {
        ...state,
        chineseCaptcha: {
          ...state.chineseCaptcha,
          visible: false
        }
      };

    case types.SET_CHINESE_CAPTCHA:
      return {
        ...state,
        chineseCaptcha: {
          ...state.chineseCaptcha,
          values: action.values
        }
      };

    case types.REMOVE_CHINESE_CAPTCHA:
      return {
        ...state,
        chineseCaptcha: {
          ...state.chineseCaptcha,
          values: null
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/xl.js